import { AdminApp } from './app/AdminApp';

function App() {
  return <AdminApp />;
}

export default App;
